import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 48, fontFamily: '"Helvetica Neue", Arial' }}>Loading&hellip;</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin)
    return (
      <div style={{ padding: 48, fontFamily: '"Helvetica Neue", Arial' }}>
        You are not authorized to access the admin panel.
      </div>
    );
  return children;
}
